<template>
  <div>
    <div class="modal__header">
      <div class="row">
        <div class="col-md-6">
          <h3>
            Flight Budget - {{ start_date | formatDate }}
          </h3>
        </div>
        <div class="col-md-2">
          <button class="button button--primary">
            <span>Reload</span>
          </button>
        </div>
      </div>
    </div>
    <div class="modal__body mt-4">
      <div class="row" v-if="mainLoader">
        <div class="col-md-12">
          <div class="loader"></div> 
          <div class="loader-written"></div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-md-12"> 
          <template v-if="flightBudgetData.length > 0">
            <div class="flight--section mt-3" v-for="(selectedInstace, index) in flightBudgetData" :key="index">
              <div class="row col-md-12 p-3">
                <div class="row">
                  <div class="col-md-1" style="width: 2.333333% !important; display: flex; align-items: center; justify-content: center;margin-left: 15px;">
                    <img src="../../../assets/img/flight-plane-svgrepo-com.svg" height="30px" width="30px"/>
                  </div>
                  <div class="col-md-11 flight-section-header">
                    <div class="row">
                      <div class="col-md-6">
                        <template v-if="selectedInstace.instance.instance_headers.length > 0">
                          <div class="row" v-for="(header, headerIndex) in selectedInstace.instance.instance_headers" :key="headerIndex">
                            <div class="col-md-12">
                              &nbsp;
                              {{ header.departure_airport.iata_code }}
                              - 
                              {{ header.arrival_airport.iata_code }}  
                              &nbsp;
                              ( 
                                <template v-if="header.departure_airline.web_url">
                                  <a :href="header.departure_airline.web_url" target="_blank">
                                    {{ header.departure_airline.name }}
                                  </a> 
                                </template>
                                <template v-else>
                                  <a :href="`${baseUrl}/airlines/edit/${header.departure_airline.id}`" target="_blank">
                                    {{ header.departure_airline.name }}
                                  </a> 
                                </template>
                              ) 
                            </div>
                          </div>
                        </template>
                      </div>
                      <div class="col-md-6">
                        <a href="javascript:void(0)" class="btn btn-outline-primary" style="float: right;" title="Refresh Flight Budget" @click="reloadFlightBudget(selectedInstace.instance.id)">
                          <img src="../../../assets/img/refresh-3104.svg" height="20px" width="20px" class="mr-2"/>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr/>
              <div class="row">
                <div class="col-md-12">
                  <div class="table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Flights</th>
                          <th>Budgeted Cost</th>
                          <th>New Cost</th>
                          <th>Last Cached</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <div class="row" v-for="(flight, flightIndex) in selectedInstace.instance.flights" :key="flightIndex">
                              <div class="col-md-12">
                               <span class="text-primary"> {{ flight.departure_airport.iata_code }} </span> 
                               <template v-if="flight.flight_cost">
                                ({{ flight.flight_cost | formatCurrency }})
                               </template>
                                - 
                               <span class="text-primary"> {{ flight.arrival_airport.iata_code }} </span> 
                               <template v-if="flight.flight_cost">
                                ({{ flight.flight_cost | formatCurrency }})
                               </template>
                              </div>
                            </div>
                          </td>
                          <td>
                           {{ selectedInstace.instance.flight_budget_cost | formatCurrency }}
                          </td>
                          <td>
                            <template v-if="selectedInstace.instance.budget_details[0].status">
                              {{ selectedInstace.instance.budget_details[0].price_details.price.amount | formatCurrency }}
                            </template>
                            <template v-else>
                              <a href="javascript:void(0)" target="_blank">
                                {{ selectedInstace.instance.budget_details[0].message }}
                              </a>
                            </template>
                          </td>
                          <td>
                            <template v-if="selectedInstace.instance.budget_details[0].status">
                              {{ selectedInstace.instance.budget_details[0].last_cached_at | formatDateTime }}
                            </template>
                            <template v-else>
                              --
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="row mt-3" v-if="dataFetchLoader">
            <div class="col-md-12">
              <!-- Skeleton Loading -->
              <div class="skeleton-card">
                <div class="skeleton-card-header">
                  <div class="skeleton plane-icon"></div>
                  <div class="skeleton route"></div>
                  <div class="skeleton airline"></div>
                </div>

                <div class="skeleton-card-table">
                  <div class="skeleton-card-row">
                    <div class="skeleton sm"></div>
                    <div class="skeleton sm"></div>
                    <div class="skeleton sm"></div>
                    <div class="skeleton sm"></div>
                    <div class="skeleton sm"></div>
                    <div class="skeleton sm"></div>
                  </div>
                  <div class="row">
                    <div class="skeleton lg"></div>
                  </div>
                  <div class="row mt-2">
                    <div class="skeleton lg"></div>
                  </div>
                  <div class="row mt-2">
                    <div class="skeleton lg"></div>
                  </div>
                </div>
              </div>
              <!-- Skeleton Loading -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'InstanceFlightBudget',
    props: {
        start_date: {
            type: String,
            required: true
        },
        selectedInstancesForFlightTimeCheck: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            mainLoader: true,
            dataFetchLoader: false,
            flightBudgetData: [],
            batchedInstances: [],
        }
    },
    async mounted() {
      await this.getFlightBudgetForInstances();
    },
    methods: {
      async getFlightBudgetForInstances() {
          let __this = this;
          if (this.selectedInstancesForFlightTimeCheck.length > 0) {
              this.mainLoader = true;
              // Step 1 : From the selected instances, create a batch of two instances
              this.batchedInstances = []; 
              for (let i = 0; i < this.selectedInstancesForFlightTimeCheck.length; i += 2) {
                  this.batchedInstances.push({
                      batchId: Math.random().toString(36).substr(2, 9),
                      isFetchd: false,
                      instances: this.selectedInstancesForFlightTimeCheck.slice(i, i + 2)
                  });
              }

            // Step 2 : Fetch flight times for each batch
              let loadingIndex = 0
              __this.flightBudgetData = []; // Reset flightBudgetData
              for (const batch of this.batchedInstances) { 
                try {
                    if (loadingIndex > 0) {
                      __this.dataFetchLoader = true; // Show loader for subsequent batches
                    } 

                    const response = await this.fetchDataFromServer(batch.instances);
                    if (response.data.length > 0) {
                        // Process the response and add to flightBudgetData
                        response.data.forEach(element => {
                            __this.flightBudgetData.push({
                              instance: element.instance,
                            });
                        });
                    } 
                    batch.isFetchd = true;
                    __this.mainLoader = false; 
                    __this.dataFetchLoader = false; 
                    loadingIndex++;
                  } catch (error) {
                      console.error('Error fetching flight times:', error);
                  }

                  await this.sleep(1000);
              }
          }
      },
      fetchDataFromServer(instanceIds) {
          return new Promise((resolve, reject) => {
              fetch(this.$api + 'tours/instances/check/instance-flight-budget', {
                  method: 'POST',
                  body: JSON.stringify({
                    tour_instance_id: instanceIds
                  }),
                  headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                      'Authorization': localStorage.getItem('token')
                  }
              })
              .then(res => res.json())
              .then(response => {
                  if (response.status) {
                      resolve(response);
                  } else {
                      reject(response);
                  }
              })
              .catch(error => {
                  reject(error);
              });
          });
      },
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      reloadFlightBudget(instanceId) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'tours/instances/budget/reload-flight-budget', {
          method: 'POST',
          body: JSON.stringify({
            instance_id: instanceId
          }),
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
          .then(response => {
            this.$store.dispatch('setLoadStatus')
            if (response.status) {
              let fetchedUpdatedInstance = response.data.data[0]
              let index = this.flightBudgetData.findIndex(item => item.instance.id === fetchedUpdatedInstance.instance.id);
              if (index !== -1) {
                this.flightBudgetData[index].instance = fetchedUpdatedInstance.instance;
              } else {
                this.flightBudgetData.push({
                  instance: fetchedUpdatedInstance.instance
                });
              }
            } else {
                this.$toast.error(response.message || 'Failed to reload flight budget');
            }
        })
        .catch(error => {
            reject(error);
        });
      }
  },
}
</script>

<style scoped>
.flight--section {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 10px;
}
.heartbeat {
  animation: heartbeat 1.2s infinite;
}

.flight-section-header{
  font-size: 1.7rem;
  font-weight: 600;
  margin-bottom: 0px !important;
}

@keyframes heartbeat {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  25% {
    transform: scale(1.2);
    opacity: 0.6;
  }
  40% {
    transform: scale(0.95);
    opacity: 1;
  }
  60% {
    transform: scale(1.15);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.loader {
  height: 60px;
  aspect-ratio: 2;
  border-bottom: 3px solid #0000;
  background: 
    linear-gradient(90deg,#524656 50%,#0000 0)
    -25% 100%/50% 3px repeat-x border-box;
  position: relative;
  animation: l3-0 .75s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader:before {
  content: "";
  position: absolute;
  inset: auto 42.5% 0;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #CF4647;
  animation: l3-1 .75s cubic-bezier(0,900,1,900) infinite;
}
@keyframes l3-0 {
  to {background-position: -125% 100%}
}
@keyframes l3-1 {
  0%,2% {bottom: 0%}
  98%,to {bottom:.1%}
}

/* HTML:  */
.loader-written {
  width: fit-content;
  font-weight: bold;
  font-family: monospace;
  font-size: 30px;
  color: #0000;
  background: linear-gradient(90deg,#C02942 calc(50% + 0.5ch),#000 0) right/calc(200% + 1ch) 100%;
  -webkit-background-clip: text;
          background-clip: text;
  animation: l7 2s infinite steps(11);
   position: relative;
  animation: l3-0 .75s linear infinite;
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader-written:before {
  content:"Loading..."
}
@keyframes l7 {to{background-position: left}}

.skeleton-card {
  background: white;
  border-radius: 12px;
  width: auto;
  padding: 30px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 10px;
}

.skeleton {
  background: linear-gradient(90deg, #ececec 25%, #f3f3f3 37%, #ececec 63%);
  background-size: 400% 100%;
  animation: shimmer 1.4s infinite linear;
  border-radius: 8px;
}

@keyframes shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}

.skeleton-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.plane-icon {
  width: 24px;
  height: 24px;
}

.route,
.airline {
  height: 20px;
  width: 120px;
}

.skeleton-card-table {
  width: 100%;
  border-collapse: collapse;
}

 

.skeleton-card-table .skeleton-card-row {
  display: grid;
  grid-template-columns: 1.5fr 1.5fr 1.5fr 2fr 2fr 1fr;
  gap: 10px;
  margin-bottom: 12px;
}

.skeleton.sm {
  height: 14px;
  width: 100%;
}

.skeleton.md {
  height: 18px;
  width: 100px;
}

.skeleton.lg {
  height: 15px;
  width: 100%;
}

.flight--section .flight-section-header img:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease;
  color: #ececec;
}
</style>